<ng-container *ngIf="canView">
    <mat-expansion-panel *ngIf="!isValidating" [expanded]="true" style="margin: 10px 0px;">

        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon style="margin-top: -3px; margin-right: 5px;">sort</mat-icon>Ranking Servicios por {{getTraduccion('Comunidad')}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
                <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="false"
                    [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                    [allowResizing]='true' *ngIf="!isSearching">
                    <e-columns>
                        <e-column field='ComunidadNombre' headerText='Comunidad'>
                            <ng-template #headerTemplate let-data>
                                {{getTraduccion('Comunidad')}}
                            </ng-template>
                        </e-column>
                        <e-column field='ServicioGastoNombre' headerText='Servicio'></e-column>
                        <e-column field='CantidadGastos' headerText='Cantidad' textAlign="right"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </mat-expansion-panel>
</ng-container>